export default {
  traceability: {
    traceability: "trazabilidad",
    coffeeTraceabilityMngmnt: "Gestión de trazabilidad del café",
    traceabilityPage: "Página de trazabilidad",
    labelDesigner: "Diseñador de etiquetas",
    additionalInformation: "Información adicional",
    info1:
      "Proporciona información sobre los logotipos adicionales de tu producto. Esta información estará disponible al público en la página de trazabilidad del café.",
    addSlogan: "Agregar eslogan",
    sloganTooltip: "Agrega un eslogan para tu producto",
    additionalLogos: "Logotipos adicionales",
    title: "Título",
    description: "Descripción",
    mapLink: "Enlace al mapa",
    websiteLink: "Enlace al sitio web",
    addMedia: "Agregar medios",
    uploadImageVideo: "Subir imagen/video",
    origin: "Origen",
    info2:
      "Proporciona información sobre el país de origen de tu producto. Esta información estará disponible al público en la página de trazabilidad del café.",
    countryImage: "Imagen del país",
    institutionalInfo: "Información institucional",
    info3:
      "Proporciona información sobre tu empresa/cooperativa, cuéntale a los consumidores sobre el trabajo relevante que has estado haciendo. Esta información estará disponible al público en la página de trazabilidad del café.",
    cooperativeLogo: "Logotipo de la cooperativa",
    traceabilityIntro: "Introducción a la trazabilidad",
    info4:
      "Esta sección le dará al consumidor acceso a toda la historia de producción y procesamiento del café. Describe la importancia de la trazabilidad para tu empresa/cooperativa y para el mundo.",
    addLabel: "Agregar etiqueta",
    chooseTitle: "Elegir título",
    chooseLabelDesign: "Elegir plantilla de diseño de etiqueta",
    uploadYourLogo: "Subir tu logotipo",
    info5:
      "Instrucciones: El tamaño de la imagen debe ser de al menos 1000 x 1000 píxeles cuadrados. Puedes elegir un PNG transparente para que se sincronice con los colores de fondo.",
    chooseTemplateColors: "Elegir colores de la plantilla",
    backgroundColor: "Color de fondo",
    foregroundColor: "Color principal",
    labelStatus: "Estado de la etiqueta",
    inactive: "Inactivo",
    download: "Descargar",
    enterLabelTitle: "Introduce el título de la etiqueta",
  },
  cacaoTraceability: {
    traceability: "trazabilidad",
    cacaoTraceabilityMngmnt: "Gestión de trazabilidad del cacao",
    traceabilityPage: "Página de trazabilidad",
    labelDesigner: "Diseñador de etiquetas",
    additionalInformation: "Información adicional",
    info1:
      "Proporciona información sobre los logotipos adicionales de tu producto. Esta información estará disponible al público en la página de trazabilidad del cacao.",
    addSlogan: "Agregar eslogan",
    additionalLogos: "Logotipos adicionales",
    title: "Título",
    description: "Descripción",
    mapLink: "Enlace al mapa",
    websiteLink: "Enlace al sitio web",
    addMedia: "Agregar medios",
    uploadImageVideo: "Subir imagen/video",
    origin: "Origen",
    info2:
      "Proporciona información sobre el país de origen de tu producto. Esta información estará disponible al público en la página de trazabilidad del cacao.",
    countryImage: "Imagen del país",
    institutionalInfo: "Información institucional",
    info3:
      "Proporciona información sobre tu empresa/cooperativa, cuéntale a los consumidores sobre el trabajo relevante que has estado haciendo. Esta información estará disponible al público en la página de trazabilidad del cacao.",
    cooperativeLogo: "Logotipo de la cooperativa",
    traceabilityIntro: "Introducción a la trazabilidad",
    info4:
      "Esta sección le dará al consumidor acceso a toda la historia de producción y procesamiento del cacao. Describe la importancia de la trazabilidad para tu empresa/cooperativa y para el mundo.",
    addLabel: "Agregar etiqueta",
    chooseTitle: "Elegir título",
    chooseLabelDesign: "Elegir plantilla de diseño de etiqueta",
    uploadYourLogo: "Subir tu logotipo",
    info5:
      "Instrucciones: El tamaño de la imagen debe ser de al menos 1000 x 1000 píxeles cuadrados. Puedes elegir un PNG transparente para que se sincronice con los colores de fondo.",
    chooseTemplateColors: "Elegir colores de la plantilla",
    backgroundColor: "Color de fondo",
    foregroundColor: "Color principal",
    labelStatus: "Estado de la etiqueta",
    inactive: "Inactivo",
    download: "Descargar",
    enterLabelTitle: "Introduce el título de la etiqueta",
  },
}